import request from 'superagent';
import config from 'app/config';
import { getUserToken } from 'services/authentication';

export default (email, callback) => {
  const uri = `${config.get('IMPERSONATION_API_HOST')}/v1/users?email=${email}`;
  return request
    .get(uri)
    .set('Authorization', `Bearer ${getUserToken()}`)
    .end((err, res) => {
      if (err) {
        callback(err);
      } else if (res.body && 'id' in res.body) {
        callback(null, res.body.id);
      } else {
        callback('Invalid response received');
      }
    });
};
